import { Table } from 'antd'

import type { ITableProps } from '../types'

const AdministratorTable = <T extends object>({ dataSource, columns, rowKey }: ITableProps<T>): JSX.Element => (
  <Table dataSource={dataSource} columns={columns} rowKey={rowKey} />
)

export default AdministratorTable
